import { Struttura } from '@hm_app/@core/models/struttura';
import { Injectable, Type } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { Faq } from '@hm_app/@core/models/info';
import { FaqOperatore } from '@hm_app/@core/models/faq_operatore';

@Injectable()
export class FaqOperatoriService {

    // Observable sources
    private faq = new BehaviorSubject<FaqOperatore>(null);

    // Observable streams
    faqObservable = this.faq.asObservable();

    // Service message commands
    passFaqOperatore(faq: FaqOperatore) {
        this.faq.next(faq);
    }
}
